import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchChatSms } from "../../actions/fetchChatSms.actions";

export const CHAT_SMS_QUERY_KEY = ["sms", "chat"];


export const normalizeSmsPhone = (phone?: string | null): string => {
  return String(phone ?? "").replace(/\D/g, "");
};

export const getChatSmsQueryKey = (
  phoneNumber?: string | null,
  from?: string | null,
  companyId?: number | string | null,
  search = "",
) => [
    ...CHAT_SMS_QUERY_KEY,
    normalizeSmsPhone(phoneNumber),
    normalizeSmsPhone(from),
    companyId != null ? String(companyId) : "",
    search,
  ];

export const useChatSmsInfinite = (
  phoneNumber?: string,
  from?: string,
  companyId?: number | string | null,
  limit = 20,
  search = "",
  enabled = true,
) => {
  const query = useInfiniteQuery({
    queryKey: getChatSmsQueryKey(phoneNumber, from, companyId, search),
    queryFn: ({ pageParam = 1 }) =>
      fetchChatSms({
        phoneNumber: phoneNumber!,
        from: from!,
        companyId,
        pageParam,
        limit,
        search,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (!lastPage.meta.hasNextPage) return undefined;

      return lastPage.meta.page + 1;
    },
    enabled: Boolean(phoneNumber && from && enabled),
  });

  const messages = useMemo(() => {
    const flatMessages = query.data?.pages.flatMap((page) => page.data) ?? [];
    return [...flatMessages].reverse();
  }, [query.data]);

  const rawMessages = useMemo(() => {
    return query.data?.pages.flatMap((page) => page.data) ?? [];
  }, [query.data]);

  return {
    ...query,
    messages,
    rawMessages,
  };
};
